export default "__VITE_ASSET__Dh$0o2LP__"